import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinnerFull from "../../../components/common/loading-spinner/loading-spinner-full";
import { useState } from "react";
import Header from "../../../components/common/header";
import { GET_REVIEW_BY_STORE_ID } from "../../../api/store-review-queries";
import { useQuery } from "@apollo/client";
import { GetReviewByStoreIdQuery } from "../../../__generated__/graphql";
import { useInfiniteScrollStoreReviews } from "./hooks/use-infinite-scroll-store-reviews";
import ReviewDetailModal from "../../../components/review/review-detail-modal";
import { ReviewListHeader } from "./components/review-list-header";
import { ReviewBestBlock } from "./components/review-best-block";
import { ReviewListGrid } from "./components/review-list-grid";
import { ReviewListCta } from "./components/review-list-cta";

const StoreReviewList = () => {
  const { id } = useParams();
  const storeId = parseInt(id as string);
  const [selectedReview, setSelectedReview] =
    useState<GetReviewByStoreIdQuery["getReviewByStoreId"][number]>();
  const limit = 20;

  const { data, loading, fetchMore } = useQuery(GET_REVIEW_BY_STORE_ID, {
    variables: { storeId, limit, offset: 0 },
  });
  const navigate = useNavigate();

  const { loadMoreRef, allReviews, hasMore, isLoadingMore } =
    useInfiniteScrollStoreReviews({
      storeId,
      limit,
      fetchMore,
      initialData: data?.getReviewByStoreId,
    });

  const bestReview = allReviews?.[0]?.store?.bestReview
    ? {
        ...allReviews[0].store.bestReview,
        store: allReviews[0].store,
      }
    : allReviews?.find(
        (review) => review?.reviewImages && review.reviewImages.length > 0,
      ) || allReviews?.[0];

  if (loading && allReviews.length === 0) {
    return <LoadingSpinnerFull />;
  }

  const handleBackClick = () => {
    const idx = (window.history.state && window.history.state?.idx) ?? 0;
    idx > 0 ? navigate(-1) : navigate(`/store/${id}`);
  };

  return (
    <div className="w-full h-full flex flex-col bg-white">
      <Header
        title="리뷰 전체보기"
        showBackButton
        onBackClick={handleBackClick}
      />

      <div className="flex-1 flex-col gap-4 overflow-y-scroll pb-24">
        {allReviews.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-[300px]">
            <p className="text-gray-500 text-lg text-center">
              아직 리뷰가 없어요.
              <br />
              첫 리뷰를 남겨보세요!
            </p>
          </div>
        ) : (
          <div className="w-full">
            <ReviewListHeader
              storeImg={bestReview?.store?.img}
              storeTitle={bestReview?.store?.title}
            />
            <ReviewBestBlock
              reviewImages={bestReview?.reviewImages as Array<{ img?: string | null } | null> | null | undefined}
              content={bestReview?.content}
            />
            <ReviewListGrid
              reviews={allReviews}
              storeId={storeId}
              onSelectReview={setSelectedReview}
              loadMoreRef={loadMoreRef}
              hasMore={hasMore}
              isLoadingMore={isLoadingMore}
            />
          </div>
        )}
      </div>

      <ReviewListCta onExplore={() => navigate("/explore")} />

      <ReviewDetailModal
        review={selectedReview}
        onClose={() => setSelectedReview(undefined)}
      />
    </div>
  );
};

export default StoreReviewList;
